/**
 * Reducer for managing kits within a collection
 */

import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const kitCollectionItemsReducer = (state = {}, action) => {
  let kitCollectionItems;
  try {
    kitCollectionItems = action.response.entities.kitCollectionItems;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.REMOVE_KIT_FROM_COLLECTION_SUCCESS: {
      const newState = { ...state };
      delete newState[action.kitCollectionItemId];
      return newState;
    }

    default: {
      if (kitCollectionItems) return _merge({}, state, kitCollectionItems);
      return state;
    }
  }
};

export default kitCollectionItemsReducer;
